import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import cn from 'classnames';
import styles from './ProgressiveImage.scss';

class ProgressiveImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSmallImageLoad: null,
      onBigImageLoad: null,
      smallImageLoaded: false,
      bigImageLoaded: false
    };
  }

  componentDidMount() {
    this.followSmallImage();
  }

  componentDidUpdate() {
    const { smallImageLoaded, bigImageLoaded, onBigImageLoad } = this.state;
    if (smallImageLoaded && !bigImageLoaded && !onBigImageLoad) {
      this.followBigImage();
    }
  }

  componentWillUnmount() {
    const { onSmallImageLoad, onBigImageLoad } = this.state;
    if (onSmallImageLoad) {
      const smallImage = ReactDOM.findDOMNode(this.refs.smallImage);
      smallImage.removeEventListener('load', onSmallImageLoad);
    }
    if (onBigImageLoad) {
      const bigImage = ReactDOM.findDOMNode(this.refs.bigImage);
      bigImage.removeEventListener('load', onBigImageLoad);
    }
  }

  followSmallImage() {
    const { handleSmallImageLoad } = this.props;

    const image = ReactDOM.findDOMNode(this.refs.smallImage);
    if (image.complete) {
      this.setState({ smallImageLoaded: true });
      if (handleSmallImageLoad) {
        handleSmallImageLoad();
      }
      return;
    }

    const onSmallImageLoad = () => {
      this.setState({ onSmallImageLoad: null, smallImageLoaded: true }, () => {
        image.removeEventListener('load', onSmallImageLoad);
        if (handleSmallImageLoad) {
          handleSmallImageLoad();
        }
      });
    };
    this.setState({ onSmallImageLoad }, () => {
      image.addEventListener('load', onSmallImageLoad);
    });
  }

  followBigImage() {
    const { handleBigImageLoad } = this.props;

    const image = ReactDOM.findDOMNode(this.refs.bigImage);
    if (image.complete) {
      this.setState({ bigImageLoaded: true });
      if (handleBigImageLoad) {
        handleBigImageLoad();
      }
      return;
    }

    const onBigImageLoad = () => {
      this.setState({ onBigImageLoad: null, bigImageLoaded: true }, () => {
        image.removeEventListener('load', onBigImageLoad);
        if (handleBigImageLoad) {
          handleBigImageLoad();
        }
      });
    };
    this.setState({ onBigImageLoad }, () => {
      image.addEventListener('load', onBigImageLoad);
    });
  }

  render() {
    const { smallImageLoaded, bigImageLoaded } = this.state;
    const {
      className, smallImageClassName, bigImageClassName,
      getSmallImageSrc, handleSmallImageError,
      getBigImageSrc, handleBigImageError,
      imageAlt, width, isPopup
    } = this.props;

    return (
      <div className={cn(isPopup ? styles.ImageContainer : styles.ImageContainerShort, className)} style={{ width }} ref="ImageContainerRef">
        {
          smallImageLoaded &&
          <img
            ref="bigImage"
            className={cn(styles.BigImage, bigImageClassName, { [styles.BigImageShow]: smallImageLoaded })}
            alt={imageAlt}
            onError={handleBigImageError}
            src={getBigImageSrc(this.refs.bigImage)}
          />
        }
        <img
          ref="smallImage"
          className={cn(styles.SmallImage, smallImageClassName, { [styles.SmallImageHide]: bigImageLoaded })}
          alt={imageAlt}
          src={getSmallImageSrc(this.refs.smallImage)}
          onError={handleSmallImageError}
        />
      </div>
    );
  }
}

export default ProgressiveImage;



// WEBPACK FOOTER //
// ./src/components/common/ProgressiveImage/ProgressiveImage.js